import { SET_REDIRECT_URL } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const redirectUrl = (state = '', action: reduxStoreTypes.redirectUrlAction) => {
    if (action.type === SET_REDIRECT_URL) {
        return action.redirectUrl
    }
    return state
}
export default redirectUrl